/*
 * File: FormModel.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/08/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Model for the form builder component to build out the data
 * needed to create/edit an order
 */
export default [
  {
    name: "typeId",
    label: "Type",
    type: "select",
    required: true,
    placeholder: "Order Type",
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "shortDescription",
    label: "Short Description",
    type: "text",
    required: true
  },
  {
    name: "longDescription",
    label: "Long Description",
    type: "textarea"
  },
  {
    name: "providerId",
    label: "Provider",
    type: "select",
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "orderStatusId",
    label: "Status",
    type: "select",
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "officeId",
    label: "Office",
    type: "select",
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },

  // this is removed if the order is not associated with a patient
  {
    name: "incidentId",
    label: "Incident",
    type: "select",
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "assignedToUserId",
    label: "Assigned To",
    type: "select",
    required: true,
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "due",
    label: "Due",
    type: "date",
    format: "MM/DD/YYYY",
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "urgent",
    label: "Urgent Order",
    type: "checkbox",
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "orderNote",
    label: "Order Notes",
    type: "textarea"
  }
];
